<template>
  <div class="product-list-header">
    <button class="back-btn iconfont" type="button" @click="$router.go(-1)">&#xe64f;</button>
    <div class="common-search">
      <input type="text" :placeholder="placeholderText" autocomplete="off" v-model="keywords" @keyup.enter="search(keywords)">
      <button class="submit-btn iconfont" type="button" @click="search(keywords)">&#xe689;</button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      keywords: this.keyword ? this.keyword : '',
      currenKeywords: this.utils.fetch(this.searchType === 'suppliers' ? 'store_search_history' : 'product_keyword')
    }
  },
  props: {
    keyword: {
      type: String,
      default: ''
    },
    searchType: {
      type: String,
      default: 'products'
    }
  },
  computed: {
    placeholderText () {
      return this.searchType === 'suppliers' ? 'Search Suppliers' : 'Search Products'
    }
  },
  methods: {
    ...mapMutations({
      'changeKey': 'changeKey'
    }),
    // 分类列表进入到搜索，完成后跳转到商品列表页面
    search (value) {
      if (value.replace(/\s+/g, '').length <= 0) {
        Toast('Please enter the keywords you want to search')
        return false
      } else {
        this.keywords = value
      }
      if (value) {
        const historyKey = this.searchType === 'suppliers' ? 'store_search_history' : 'product_keyword'
        this.currenKeywords = this.utils.fetch(historyKey) || []
        this.currenKeywords.push(value)
        let data = this.utils.arrayFilter(this.currenKeywords)
        this.utils.save(historyKey, data)
      }
      this.changeKey(this.keywords)
      if (this.searchType === 'suppliers') {
        this.$router.push({
          name: 'HomeStorelist',
          query: { keywords: this.keywords }
        })
      } else {
        this.$router.push({
          name: 'HomeGoodslist',
          query: { keywords: this.keywords }
        })
      }
    },
    // 取消返回上一级
    cancel () {
      this.clear()
      let isFromHome = this.$route.params.isFromHome || this.$route.query.fromHome
      if (isFromHome) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'category' })
      }
    },

    clear () {
      this.keywords = ''
      this.changeKey(this.keywords)
    }
  }
}
</script>

<style scoped lang="scss">
  .product-list-header {
    display: flex;
    height: 2.65rem;
    padding: 0.35rem 0.55rem 0.25rem;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
  }
  .back-btn {
    width: 1.2rem;
    height: 1.8rem;
    border: 0;
    background: transparent;
    color: #24272c;
    font-size: 0.8rem;
    line-height: 1.8rem;
    text-align: left;
    padding: 0;
    flex-shrink: 0;
  }
  .common-search{
    flex: 1;
    min-width: 0;
    height: 1.8rem;
    display: flex;
    align-items: center;
    border: 0.05rem solid #222;
    border-radius: 0.9rem;
    background: #f5f6f7;
    overflow: hidden;
  }
  .common-search input {
    box-sizing: border-box;
    flex: 1;
    min-width: 0;
    width: auto;
    height: 1.7rem;
    background: transparent;
    font-size: 0.65rem;
    color: #333;
    padding: 0 0.25rem 0 0.55rem;
    border: 0;
    outline: none;
  }
  .common-search input::-webkit-input-placeholder {
    color: #8d8d8d;
  }
  .common-search input::-moz-placeholder {
    color: #8d8d8d;
  }
  .submit-btn {
    border: 0;
    background: transparent;
    flex-shrink: 0;
    padding: 0;
    text-align: center;
  }
  .submit-btn {
    width: 2.45rem;
    height: 1.55rem;
    margin-right: 0.1rem;
    line-height: 1.55rem;
    border-radius: 0.78rem;
    background: #1f2022;
    color: #fff;
    font-size: 0.95rem;
  }
</style>
